import I18n from '../../../../localization';
import { maskedSn, nodeId } from '../../../../utils/utility';

const HQ_X = 40;
const HD_X = 170;
const HVAC_X = 400;
const ROW_GAP = 110;

export const createInitialNodes = (airDevices = [], hvacs = [], deleteHvac, fromManageHVACSystem) => {
  const primaryIds = new Set(
    airDevices.filter(a => a['primary-device-id']).map(a => a['primary-device-id'])
  );

  const airNodes = airDevices.map((ad, index) => {
    const hasChild = primaryIds.has(ad['device-id']);

    const positions = ad.primary
      ? {
          right: { type: 'source' },
          ...(hasChild && { bottom: { type: 'source' } })
        }
      : {
          right: { type: 'source' },
          left: { type: 'target' }
        };

    return {
      id: nodeId(ad.name, ad['device-id']),
      type: 'card',
      position: { x: ad.primary ? HQ_X : HD_X, y: index * ROW_GAP },
      data: {
        title: ad.primary ? I18n.t("mobile.AirDeviceProvisioning.iqAirPrimary") : I18n.t("mobile.AirDeviceProvisioning.iqAirSecondary"),
        subtitle: ad.primary ? ad.name : maskedSn(ad['serial-number']),
        border: '#F29A45',
        active: true,
        positionArray: positions,
        secondary: !ad.primary
      },
      draggable: false
    };
  });

  const airHeight = airNodes.length * ROW_GAP;
  let unlinkedIndex = 0;

  const hvacNodes = hvacs.map((hv, index) => {
    const isUnlinked = !hv['linked-air-devices']?.length;
    const y = isUnlinked ? airHeight + ROW_GAP * unlinkedIndex++ : index * ROW_GAP;

    return {
      id: nodeId(hv.name, hv['device-id']),
      type: 'card',
      position: { x: HVAC_X, y },
      data: {
        title: I18n.t('mobile.hvac.title'),
        subtitle: hv.name,
        border: '#6B7176',
        positionArray: {
          left: { type: 'target' },
          bottom: { type: 'target' }
        },
        isRemovable: isUnlinked,
        deleteHvac,
        fromManageHVACSystem
      },
      draggable: false
    };
  });

  return [...airNodes, ...hvacNodes];
};
